import React from 'react';
import { Navigate } from 'react-router-dom';

// Only carriers are required to have an active subscription to access the platform.
// Shippers and brokers are granted direct dashboard access after sign-in.
const ROLES_REQUIRING_SUBSCRIPTION = ['carrier'];

const ProtectedRoute = ({ children }) => {
  const userStr = localStorage.getItem('user');
  const token = localStorage.getItem('jwtToken');

  if (!token || !userStr) {
    return <Navigate to="/" replace />;
  }

  const user = JSON.parse(userStr);

  if (user.role === 'Admin' || user.role === 'admin') {
    return children;
  }

  // Only check subscription status for roles that require it (i.e., carrier)
  if (ROLES_REQUIRING_SUBSCRIPTION.includes(user.role)) {
    const validStatuses = ['on_trial', 'trialing', 'active', 'paid', 'on_trial'];
    const hasActiveSubscription = validStatuses.includes(user.subscription_status);
    if (!hasActiveSubscription) {
      return <Navigate to="/payment" replace />;
    }
  }

  return children;
};

export default ProtectedRoute;